function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "12",
  height: "12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M2.321 0v1.2H1.69C.995 1.2.427 1.74.427 2.4v8.4c0 .66.568 1.2 1.263 1.2h8.842c.695 0 1.263-.54 1.263-1.2H1.69v-6h10.105V2.4c0-.66-.568-1.2-1.263-1.2H9.9V0H8.637v1.2H3.585V0H2.32zM1.69 2.4h8.842v1.2H1.69V2.4zM10.532 6v1.2H6.111v1.2h4.421v1.2l1.263-1.2.632-.6-.632-.6L10.532 6z",
  fill: "#000"
})));